import { render } from "./AppDesktop.layout.vue?vue&type=template&id=7368db08"
import script from "./AppDesktop.layout.vue?vue&type=script&lang=js"
export * from "./AppDesktop.layout.vue?vue&type=script&lang=js"

import "./AppDesktop.layout.vue?vue&type=style&index=0&id=7368db08&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QLayout});
